<template>
    <div id="myBusiness">
        <div class="flex-start" style="width:10rem;height:1.17rem;background:rgba(255,255,255,1);">
            <div v-for="(item,index) in ['待办','办理中','全部']" @click="tabIndex=index;" class="flex-center" style="position: relative;width:3.33rem;height:100%;">
                <div :style="'text-align: center;font-size:0.37rem;font-family:PingFang SC;font-weight:400;'+(tabIndex==index?'color:rgba(230,154,97,1);':'color:rgba(0,0,0,1);')">{{item}}</div>

                <div v-show="tabIndex==index" style="position: absolute;left:0.47rem;bottom: 0rem;width:2.4rem;height:0.08rem;background:rgba(230,154,97,1);border-radius:0.04rem;"></div>
            </div>
        </div>

        <div>
            <div v-for="(item,index) in  [{status:'待办'},{status:'办理中'},{status:'已完成'},{status:'无效'},{status:'待办'}]" style="margin-top:0.32rem;margin-left:0.32rem;width:9.36rem;height:2rem;background:rgba(255,255,255,1);border-radius:0.27rem;">
                <div class="flex-between" style="padding:0.52rem 0 0.31rem;">
                    <div :style="'margin-left:0.44rem;height:0.39rem;line-height:0.39rem;font-size:0.4rem;font-family:PingFang SC;font-weight:bold;'+getCardStyle(item.status).topLeftTextStyle">一键救援</div>
                    <div :style="'margin-right:0.55rem;height:0.35rem;line-height:0.35rem;font-size:0.37rem;font-family:PingFang SC;font-weight:500;'+getCardStyle(item.status).topRightTextStyle">{{item.status}}</div>
                </div>

                <div :style="'margin-left:0.44rem;height:0.25rem;line-height:0.25rem;font-size:0.32rem;font-family:PingFang SC;font-weight:400;'+getCardStyle(item.status).bottomTextStyle">2019-12-12 09:56:20</div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "myBusiness",
        data() {
            return {
                tabIndex:0,
            }
        },
        methods: {
            getCardStyle(status){
                let statusToCardStyle={
                    '待办':{
                        topLeftTextStyle:'color:rgba(51,51,51,1);',
                        topRightTextStyle:'color:rgba(230,154,97,1);',
                        bottomTextStyle:'color:rgba(153,153,153,1);'
                    },
                    '办理中':{
                        topLeftTextStyle:'color:rgba(51,51,51,1);',
                        topRightTextStyle:'color:rgba(230,154,97,1);',
                        bottomTextStyle:'color:rgba(153,153,153,1);'
                    },
                    '已完成':{
                        topLeftTextStyle:'color:rgba(51,51,51,1);',
                        topRightTextStyle:'color:rgba(54,199,136,1);',
                        bottomTextStyle:'color:rgba(153,153,153,1);'
                    },
                    '无效':{
                        topLeftTextStyle:'color:rgba(204,204,204,1);',
                        topRightTextStyle:'color:rgba(204,204,204,1);',
                        bottomTextStyle:'color:rgba(204,204,204,1);'
                    }
                }

                return statusToCardStyle[status]
            },

        }
    }
</script>

<style scoped>
    #myBusiness{
        background-color:#F2F2F2;
        height: 100%;
        position: fixed;
        width: 100%;
    }

    .flex-center{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:center;
    }
    .flex-start{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-start;
    }
    .flex-end{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-end;
    }
    .flex-between{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-between;
    }
    .flex-around{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-around;
    }
</style>
